import { useRecoilValue } from 'recoil'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import equipmentSelectors from '@/pages/Equipment/equipment.selectors'
import { NavLink } from 'react-router-dom'
import urls from '@/navigation/urls.ts'
import equipmentUtils from '@/pages/Equipment/equipment.utils'

interface IProps {
  equipmentId: IEquipment['id']
}

const EquipmentAddressLink = (props: IProps) => {
  const equipmentMap = useRecoilValue(equipmentSelectors.getEquipmentMap)

  if (!equipmentMap[props.equipmentId]) return null

  return (
    <NavLink
      to={urls.liftScreen(props.equipmentId)}
      className="text-nm line-clamp text-link"
      style={{ textDecoration: 'none' }}
    >
      {equipmentUtils.getEquipmentAddress(equipmentMap[props.equipmentId].location)}
    </NavLink>
  )
}

export default EquipmentAddressLink
